import { Factory } from "fishery";
import type { BankDetailsInputType } from "../components/PaymentPrefConsolidated/Components/WirePaymentPrefInput/BankDetails/constants";

export const bankDetailsInputFactory = Factory.define<BankDetailsInputType>(() => ({
  bankCountry: "United States:Q291bnRyeU9iamVjdFR5cGU6MjM0",
  bankCountryValidatedCountry: "United States",
  bankName: "Bank of America",
  bankAddress: {
    country: "US",
    line1: "6000 Universal Boulevard",
    line2: "",
    locality: "Orlando",
    postalCode: "32819",
    region: "FL",
  },
  routingNumber: "123456780",
  swiftCode: "",
  internationalRoutingNumber: "",
  usesIntermediaryBank: false,
  intermediaryBankCountry: "",
  intermediaryBankCountryValidatedCountry: "",
  intermediaryBankName: "",
  intermediaryBankAddress: {
    street: "",
    city: "",
    state: "",
    postalCode: "",
  },
  intermediaryRoutingNumber: "",
  intermediarySwiftCode: "",
  intermediaryInternationalRoutingNumber: "",
}));
